// extracted by mini-css-extract-plugin
module.exports = {"fixedAdvanced":"_2NVx8","animat":"yUDwd","btn_box":"NxwwJ","title":"_3qY77","diff":"_1D8wP","titled":"_3uoF8","time":"_1eR7b"};